import TinyColor from "@ctrl/tinycolor";
import { BaseElement } from "@redotech/redo-content-builder-common/element-schema";
import { colorToHex, compositeColors } from "@redotech/util/color";
import { CSSProperties } from "react";

type BaseStyleProps = Pick<
  BaseElement,
  "backgroundColor" | "borderColor" | "borderWidth" | "cornerRadius" | "padding"
>;

/**
 * Color the SMS disclaimer inverts against: this element's fill composited
 * over the enclosing step or container, so a transparent or translucent fill
 * contrasts against what actually shows through it.
 */
export function childContrastBackgroundColor(
  parentBackgroundColor: string,
  ownBackgroundColor: string | undefined,
): string {
  if (!ownBackgroundColor) {
    return parentBackgroundColor;
  }
  const own = TinyColor(ownBackgroundColor);
  if (!own.isValid || own.a === 1) {
    return ownBackgroundColor;
  }
  if (own.a === 0) {
    return parentBackgroundColor;
  }
  return colorToHex(
    compositeColors(own.toRgb(), TinyColor(parentBackgroundColor).toRgb()),
  );
}

export function getBaseElementStyles(element: BaseStyleProps): CSSProperties {
  const hasBorder = element.borderWidth && element.borderWidth > 0;

  return {
    ...(element.backgroundColor && {
      backgroundColor: element.backgroundColor,
    }),
    ...(hasBorder && {
      borderColor: element.borderColor,
      borderWidth: `${element.borderWidth}px`,
      borderStyle: "solid",
    }),
    ...(element.padding?.top !== undefined && {
      paddingTop: `${element.padding.top}px`,
    }),
    ...(element.padding?.right !== undefined && {
      paddingRight: `${element.padding.right}px`,
    }),
    ...(element.padding?.bottom !== undefined && {
      paddingBottom: `${element.padding.bottom}px`,
    }),
    ...(element.padding?.left !== undefined && {
      paddingLeft: `${element.padding.left}px`,
    }),
    ...(element.cornerRadius !== undefined && {
      borderRadius: `${element.cornerRadius}px`,
      overflow: "hidden",
    }),
  };
}
